import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3bb7d4d6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3bb7d4d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsArrows: require('/opt/build/repo/components/Elements/Arrows.vue').default,ElementsProgressCircle: require('/opt/build/repo/components/Elements/ProgressCircle.vue').default})
